export default "__VITE_ASSET__B6eSqD1b__"